import React, { useState } from "react";
import { useMediaQuery } from "@mui/material";
import ProjectHelpWidgetUserMobile from "./user/ProjectHelpWidgetUserMobile";
import ProjectHelpWidgetDesktop from "./ProjectHelpWidgetDesktop";

/**
 * サジェストウィジェット（親コンポーネント）
 *
 * - 表示可否の判定
 * - desktop / mobile の分岐
 * - open 状態のみを管理
 */
export default function ProjectHelpWidget({
  mode,
  step,
  formState,
  anchorRef,
}) {
  // 画面サイズ判定
  const isDesktop = useMediaQuery("(min-width:768px)");

  // ウィジェットの開閉状態（desktop / mobile 共通）
  const [open, setOpen] = useState(false);

  // user のときだけ、page_type.content が無ければ非表示
  const contents = formState?.page_type?.contents;
  const hasContent = Array.isArray(contents)
    ? contents.length > 0
    : typeof contents === "string"
      ? contents.trim().length > 0
      : false;

  // ユーザー向け & コンテンツなし → そもそも描画しない
  if (mode === "user" && !hasContent) return null;

  // ユーザー向け & mobile → Drawer版
  if (mode === "user" && !isDesktop) {
    return (
      <ProjectHelpWidgetUserMobile
        open={open}
        setOpen={setOpen}
        step={step}
        formState={formState}
        isDesktop={isDesktop}
      />
    );
  }

  // それ以外（company / user desktop）は desktop 版
  return (
    <ProjectHelpWidgetDesktop
      mode={mode}
      step={step}
      formState={formState}
      anchorRef={anchorRef}
      open={open}
      setOpen={setOpen}
      isDesktop={isDesktop}
    />
  );
}
